module.exports = __webpack_public_path__ + "static/assets/d8dd2b39212eb3a266949b79ed400639.png";